import axios from "axios";
import { Link } from "react-router-dom";
import React, { useState, useEffect, useMemo, useCallback } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate, useLocation } from "react-router-dom";
import { GoogleMap, useJsApiLoader } from "@react-google-maps/api";
import {
  faArrowLeft,
  faEye,
  faImage,
} from "@fortawesome/free-solid-svg-icons";

const containerStyle = {
  width: "100%",
  height: "50vh",
};
const center = {
  lat: 28.641832439372656,
  lng: 77.22480777651072,
};

const MOVCDfarmerList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const initialState = location.state; // initial data passed via router
  const [farmerDetails, setFarmerDetails] = useState(initialState || null);
  const [cropSurveyData, setCropSurveyData] = useState(null);
  const [componentName, setComponentName] = useState("");
  const [activeImage, setActiveImage] = useState(null);
  const [coconutName, setCoconutName] = useState("");
   const [cropGroupName, setCropGroupName] = useState([]);
   const [cropYield, setCropYield] = useState([]);
   const [cropName, setCropName] = useState([]);
 
  const [map, setMap] = useState(null);

  // Determine schemeCodeModel from sessionStorage
  const schemeCodeModel = sessionStorage.getItem("schemeCodeModel");
  
  // Flag to ensure fetch is only done once.
  const [fetched, setFetched] = useState(false);

  // When the component mounts (or farmerDetails changes), fetch detailed data if needed
  useEffect(() => {
    if (farmerDetails && !fetched) {
      console.log("Initial farmer details:", farmerDetails);
      // For schemeCodeModel "14" or if it's not set, fetch NMEOOP details only once
      if (schemeCodeModel === "9" || !schemeCodeModel) {
        fetchDetailedDataMOVCD(farmerDetails.farmerCode.farmerCode);
        setFetched(true);
      }
    }
  }, [farmerDetails, schemeCodeModel, fetched]);

  async function fetchDetailedDataMovcd(value) {
    let result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Nature/FarmerDetails/getFarmerDetailsListNew`, {

      "schemeCode": "9",
      "orgTypeCode": 0,
      "SurveyUserCode": "0",
      "SurveyUserCode": "0",
      "stateCode": "0",
      "districtCode": "0",
      "subDistrictCode": "0",
      "farmerCode": value
    })
    farmerDetails = result.data.dataContent[0]
    setCropSurveyData(result.data.dataContent[0])
    console.log("@@@", result.data.dataContent[0], cropSurveyData)

    if (sessionStorage.getItem("schemeCodeModel") === "9") {
      console.log("multiCropGroupName", farmerDetails.farmerCode.farmerCropDetailsExtsList);
      if (farmerDetails.farmerCode.farmerCropDetailsExtsList.length !=0) {
       
        let cropGroup =
          farmerDetails.farmerCode.farmerCropDetailsExtsList[0].multiCropGroupName.split(
            "||"
          );
        setCropGroupName(cropGroup);


        let cropName =
          farmerDetails.farmerCode.farmerCropDetailsExtsList[0].multiCropName.split(
            "||"
          );
        setCropName(cropName);

        let cropYield =
          farmerDetails.farmerCode.farmerCropDetailsExtsList[0].multiYieldName.split(
            "||"
          );
        setCropYield(cropYield);
      }
    }
  }



  async function fetchDetailedDataMOVCD(value) {
    try {
      const result = await axios.post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/Nature/FarmerDetails/getFarmerDetailsListNew`,
        {
           "schemeCode": "9",
            "orgTypeCode": 0,
            "SurveyUserCode": "0",
            "SurveyUserCode": "0",
            "stateCode": "0",
            "districtCode": "0",
            "subDistrictCode": "0",
            "farmerCode": value
        }
      );
      const data = result.data.dataContent[0];
      console.log("datadatadata",data);
      // Update our local state with the fetched details
      setFarmerDetails(data);
      setCropSurveyData(data);
    } catch (error) {
      console.error("Error fetching NMEOOP details:", error);
    }
  }

  const onLoad = useCallback(
    (mapInstance) => {
      setMap(mapInstance);
      async function setupPolygons() {
        if (
          !farmerDetails ||
          !farmerDetails.farmerCode ||
          !farmerDetails.farmerCropSurveyPolygonList
        ) {
          console.log("No polygon data available");
          return;
        }
        const polygonList =
          farmerDetails.farmerCropSurveyPolygonList;
        const numPolygons = polygonList.length;
        const polygons = [];
        const markers = [];
        const infoWindows = [];

        for (let i = 0; i < numPolygons; i++) {
          let parsedPolygon;
          try {
            parsedPolygon = JSON.parse(polygonList[i].polygonShape);
          } catch (error) {
            console.error("Error parsing polygon shape:", error);
            continue;
          }
          // Create a polygon using the parsed coordinates
          const polygon = new window.google.maps.Polygon({
            paths: parsedPolygon,
            strokeColor: "#FF0000",
            strokeOpacity: 1,
            strokeWeight: 2,
            fillColor: "#FF0000",
            fillOpacity: 0.1,
            content: `Survey Code: ${polygonList[i].surveyNo || ""}`,
          });
          // Create an InfoWindow for the polygon
          const infoWindow = new window.google.maps.InfoWindow({
            content: `<div id="infoContent"><h2>Details</h2></div>`,
          });
          polygon.addListener("mouseover", function () {
            infoWindow.setContent(this.content);
            infoWindow.open(mapInstance);
          });
          polygon.addListener("mouseout", function () {
            infoWindow.close();
          });
          // Add a custom method to get bounds
          polygon.my_getBounds = function () {
            const bounds = new window.google.maps.LatLngBounds();
            polygon.getPath().forEach((element) => {
              bounds.extend(element);
            });
            return bounds;
          };

          polygon.setMap(mapInstance);
          const newCenter = polygon.my_getBounds().getCenter();
          mapInstance.setCenter(newCenter);
          // Create a marker at the polygon's center
          const marker = new window.google.maps.Marker({
            position: newCenter,
            map: mapInstance,
            title: "Click to zoom",
          });
          marker.addListener("click", () => {
            mapInstance.panTo(marker.getPosition());
            mapInstance.setZoom(18);
          });
          polygons.push(polygon);
          markers.push(marker);
          infoWindows.push(infoWindow);
        }
      }
      setupPolygons();
    },
    [farmerDetails]
  );

  const onUnmount = useCallback((mapInstance) => {
    setMap(null);
  }, []);

  // Example columns for a table if needed
  const columns = useMemo(
    () => [
      {
        header: "S.No",
        Cell: (cell) => Number(cell.row.id) + 1,
      },
      {
        accessorKey: "farmerName",
        header: "Farmer Name",
      },
      {
        accessorKey: "cropStageName",
        header: "Crop Stage",
      },
      {
        accessorKey: "cropRatio",
        header: "Ratio(%)",
      },
      {
        accessorKey: "dateofSowing",
        header: "Date of Sowing",
      },
      {
        accessorKey: "croppingPattern",
        header: "Cropping Pattern",
      },
    ],
    []
  );

  // Handle active image click for a modal (if using one)
  function handleActiveClick(index) {
    setActiveImage(index);
    console.log("Active image index:", index);
    if (cropSurveyData && cropSurveyData.farmerCropSurveyImageList) {
      const imagePath =
        cropSurveyData.farmerCropSurveyImageList[index].attPath;
      const innerHTML = `<img src="https://krishimapper.dac.gov.in/appdevapi/api/common/GetAttachbyURL?imageURL=/${imagePath}" alt="Farmer Image" class="img-fluid popupimg" />`;
      document.getElementById("modalBody").innerHTML = innerHTML;
    }
  }

 return (
  <main id="main" className="main">
    <div className="pagetitle page_title_box d-flex align-items-center justify-content-between">
      <nav>
        <h1>Farmer Details View</h1>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">Farmer</li>
          <li className="breadcrumb-item active">Farmer Details View</li>
        </ol>
      </nav>
      <button
        type="button"
        className="btn btn-success"
        onClick={() => navigate("/newadminpanel/farmer")}
      >
        <i>
          <FontAwesomeIcon icon={faArrowLeft} />
        </i>{" "}
        Back
      </button>
    </div>
    <section className="section">
      <div className="row">
        <div className="col-lg-12 dashboard">
          <div className="card">
            {console.log('mmmmmmmmmmmmm',cropSurveyData)}
            {cropSurveyData && (schemeCodeModel === "9" || !schemeCodeModel) && (
              <div className="card-body p-5 pt-2">
                {/* Polygon Details */}
                <div className="row cropview">
                  <h5 className="formgrouping">Polygon Details</h5>
                  
                    <GoogleMap
                      mapContainerStyle={containerStyle}
                      center={center}
                      zoom={18}
                      onLoad={onLoad}
                      onUnmount={onUnmount}
                      mapTypeId="satellite"
                    />
                 
                </div>
                {/* Survey Details */}
                <h5 className="formgrouping">Survey Details</h5>
                <div className="row surveydetailsbg">
                  {cropSurveyData.schemeName && (
                    <div className="col-md-3">
                      <h6>Scheme Name</h6>
                      <p>{cropSurveyData.schemeName}</p>
                    </div>
                  )}
                  {cropSurveyData.surveyUserCode && (
                    <div className="col-md-3">
                      <h6>Survey No.</h6>
                      <p>{cropSurveyData.surveyUserCode}</p>
                    </div>
                  )}
                  {cropSurveyData.totalArea && (
                    <div className="col-md-3">
                      <h6>Total Area </h6>
                      <p>{cropSurveyData.totalArea}</p>
                    </div>
                  )}
                  {cropSurveyData.landArea && (
                    <div className="col-md-3">
                      <h6>land Area</h6>
                      <p>{cropSurveyData.landArea}</p>
                    </div>
                  )}
                  {cropSurveyData.farmerName && (
                    <div className="col-md-3">
                      <h6>Farmer Name</h6>
                      <p>{cropSurveyData.farmerName}</p>
                    </div>
                  )}
                  {cropSurveyData.farmerID && (
                    <div className="col-md-3">
                      <h6>Farmer Id</h6>
                      <p>{cropSurveyData.farmerID}</p>
                    </div>
                  )}
                  {cropSurveyData.stateName && (
                    <div className="col-md-3">
                      <h6>State</h6>
                      <p>{cropSurveyData.stateName}</p>
                    </div>
                  )}
                  {cropSurveyData.districtName && (
                    <div className="col-md-3">
                      <h6>District</h6>
                      <p>{cropSurveyData.districtName}</p>
                    </div>
                  )}
                  {cropSurveyData.subDistrictName && (
                    <div className="col-md-3">
                      <h6>Sub District</h6>
                      <p>{cropSurveyData.subDistrictName}</p>
                    </div>
                  )}
                  {cropSurveyData.villageName && (
                    <div className="col-md-3">
                      <h6>Village</h6>
                      <p>{cropSurveyData.villageName}</p>
                    </div>
                  )}
                  {cropSurveyData.mobileNo && (
                    <div className="col-md-3">
                      <h6>Mobile No</h6>
                      <p>{cropSurveyData.mobileNo}</p>
                    </div>
                  )}
                  {cropSurveyData.createdOn && (
                    <div className="col-md-3">
                      <h6>Created Date</h6>
                      <p>{cropSurveyData.createdOn.split("T")[0]}</p>
                    </div>
                  )}
                </div>
               
                {/* Farmer Plot Registration List */}
                {cropSurveyData.farmerCropDetailsExtsList &&
                  cropSurveyData.farmerCropDetailsExtsList.length !== 0 && (
                    <>
                      <h5 className="formgrouping">Farmer Plot Registration List</h5>
                      <div className="row surveydetailsbg">
                        {cropSurveyData.farmerCropDetailsExtsList.map(
                          (item, index) => (
                            <React.Fragment key={index}>
                              {item.multiCropGroupName && (
                                <div className="col-md-3">
                                  <h6>MultiCrop Group Name </h6>
                                  <p>{item.multiCropGroupName}</p>
                                </div>
                              )} {item.multiCropName && (
                                <div className="col-md-3">
                                  <h6>multiCrop Name </h6>
                                  <p>{item.multiCropName}</p>
                                </div>
                              )}{item.multiYieldName && (
                                <div className="col-md-3">
                                  <h6>Multi Yield Name  </h6>
                                  <p>{item.multiYieldName}</p>
                                </div>
                              )}{item.cropGroupName && (
                                <div className="col-md-3">
                                  <h6>Crop Group Name </h6>
                                  <p>{item.cropGroupName}</p>
                                </div>
                              )}
                              {item.cropName && (
                                <div className="col-md-3">
                                  <h6>Crop Name</h6>
                                  <p>{item.cropName}</p>
                                </div>
                              )}
                              {item.cropVarietyName && (
                                <div className="col-md-3">
                                  <h6>Crop Variety Name  </h6>
                                  <p>{item.cropVarietyName}</p>
                                </div>
                              )}
                              {item.seasonName && (
                                <div className="col-md-3">
                                  <h6>Season Name</h6>
                                  <p>{item.seasonName}</p>
                                </div>
                              )}
                              {item.numofoilpalmtrees && (
                                <div className="col-md-3">
                                  <h6>Number of Oil Palm Trees</h6>
                                  <p>{item.numofoilpalmtrees}</p>
                                </div>
                              )}
                              {item.surveyNo && (
                                <div className="col-md-3">
                                  <h6>Survey No.</h6>
                                  <p>{item.surveyNo}</p>
                                </div>
                              )}
                              {item.plotCode && (
                                <div className="col-md-3">
                                  <h6>Plot Code</h6>
                                  <p>{item.plotCode}</p>
                                </div>
                              )}
                              {item.plantMonthYear && (
                                <div className="col-md-3">
                                  <h6>Plant Month/Year</h6>
                                  <p>{item.plantMonthYear}</p>
                                </div>
                              )}
                              {item.fbbProduction && (
                                <div className="col-md-3">
                                  <h6>FBB Production</h6>
                                  <p>{item.fbbProduction}</p>
                                </div>
                              )}
                              {item.agencyName && (
                                <div className="col-md-3">
                                  <h6>Agency Name</h6>
                                  <p>{item.agencyName}</p>
                                </div>
                              )}
                              {item.createdOn && (
                                <div className="col-md-3">
                                  <h6>Created On</h6>
                                  <p>{item.createdOn.split("T")[0]}</p>
                                </div>
                              )}
                            </React.Fragment>
                          )
                        )}
                      </div>
                    </>
                  )}
                {/* Farmer Crop Survey Image List */}
                {cropSurveyData.farmerCropSurveyImageList &&
                  cropSurveyData.farmerCropSurveyImageList.length > 0 && (
                    <div className="row cropview">
                      <h5 className="formgrouping">Image Details</h5>
                      {console.log("cropSurveyData$", cropSurveyData)}
                      {cropSurveyData.farmerCropSurveyImageList.map((item, index) => (
                        <React.Fragment key={index}>
                          <div className="col-md-2">
                            <img
                             
                              src={`https://krishimapper.dac.gov.in/appdevapi/api/common/GetAttachbyURL?imageURL=/${item.attPath}`}
                              alt="Farmer Image"
                              data-bs-toggle="modal"
                              data-bs-target="#staticBackdrop"
                              className="img-fluid imgdetials"
                              onClick={() => handleActiveClick(index)}
                            />
                          </div>
                          <div className="col-md-4">

<div className="row imgdetialsbg">

                            <div className="col-md-6">
                              <h6>Latitude</h6>
                              <p>{item.surveyorLat}</p>
                            </div>
                          <div className="col-md-6">
                              <h6>Longitude</h6>
                              <p>{item.surveyorLong}</p>
                            </div>
                          </div>
                          </div>
                        </React.Fragment>
                      ))}
                    </div>
                  )}
              </div>
            )}
          </div>
        </div>
      </div>
      </section>
    </main>
  );
};

export default MOVCDfarmerList;
